import { createBrowserRouter } from 'react-router';
import { RootLayout } from './components/RootLayout';
import { ArtistDetailPage } from './pages/ArtistDetail';
import { ArtistsPage } from './pages/Artists';
import { HomePage } from './pages/Home';
import { NotFoundPage } from './pages/NotFound';
import { PrivacyPage } from './pages/Privacy';
import { StudioPage } from './pages/Studio';
import { WorkDetailPage } from './pages/WorkDetail';
import { WorksPage } from './pages/Works';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    children: [
      { index: true, Component: HomePage },
      { path: 'lavori', Component: WorksPage },
      { path: 'lavori/:id', Component: WorkDetailPage },
      { path: 'artisti', Component: ArtistsPage },
      { path: 'artisti/:slug', Component: ArtistDetailPage },
      { path: 'studio', Component: StudioPage },
      { path: 'privacy', Component: PrivacyPage },
      { path: '*', Component: NotFoundPage },
    ],
  },
]);
